import type { ReactNode } from 'react'

/** Detail-Kopf als Statusband: Chips (Typ, Status …) + Zähler (Wert/Beschriftung) + optionale Textangaben. */
export interface Zaehler { label: string; wert: ReactNode; hinweis?: string }

export function Statusband({ chips, zaehler, angaben }: { chips?: ReactNode; zaehler?: Zaehler[]; angaben?: ReactNode }) {
  return (
    <div className="mt-2 space-y-2" data-testid="statusband">
      {chips && <div className="flex flex-wrap items-center gap-2">{chips}</div>}
      {zaehler && zaehler.length > 0 && (
        <div className="flex flex-wrap gap-2" role="group" aria-label="Kennzahlen">
          {zaehler.map(z => (
            <div key={z.label} title={z.hinweis} className="inline-flex min-h-[32px] items-center gap-1.5 rounded-full border border-dark-border bg-dark-bg-tertiary/30 px-3 text-sm text-dark-text-muted">
              <span className="font-semibold tabular-nums text-dark-text">{z.wert}</span><span>{z.label}</span>
            </div>
          ))}
        </div>
      )}
      {angaben && <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-dark-text-muted">{angaben}</div>}
    </div>
  )
}

/** Dauer in Stunden (z. B. „1,5 h“) aus Zeitpaaren; ohne gültige Paare „0 h“. */
export function stundenText(paare: Array<{ startzeit?: string | null; endzeit?: string | null }>): string {
  const min = paare.reduce((s, f) => {
    if (!f.startzeit || !f.endzeit) return s
    const ms = new Date(f.endzeit).getTime() - new Date(f.startzeit).getTime()
    return ms > 0 ? s + ms / 60000 : s
  }, 0)
  return `${(min / 60).toFixed(1).replace('.', ',')} h`
}
